import React from 'react';

// URL du nouveau logo Bénévol'Check
const LOGO_URL = "https://static.prod-images.emergentagent.com/jobs/1472cd9c-8a7f-43cf-aa2a-b29db8623d83/images/7ac324b5faacd922709a8d3826620defd5dabcad191de1fdd64d06e256d8e86a.png";

// Couleurs institutionnelles France Bénévolat : Rouge #E30613 et Bleu #003DA5
const BenevolCheckLogo = ({ size = 'md', showText = true, className = '' }) => {
  const sizes = {
    sm: { icon: 44, text: 'text-lg' },
    md: { icon: 56, text: 'text-xl' },
    lg: { icon: 72, text: 'text-2xl' },
    xl: { icon: 88, text: 'text-3xl' }
  };

  const { icon, text } = sizes[size] || sizes.md;

  return (
    <div className={`flex items-center gap-3 ${className}`}>
      <img 
        src={LOGO_URL}
        alt="Bénévol'Check"
        width={icon}
        height={icon}
        className="flex-shrink-0"
      />
      
      {showText && (
        <div className="flex flex-col">
          <span className={`font-bold ${text} leading-tight`} style={{ color: '#003DA5' }}>
            Bénévol'Check
          </span>
          <span className="text-xs font-medium tracking-wide" style={{ color: '#E30613' }}>
            Attestation de compétences
          </span>
        </div>
      )}
    </div>
  );
};

// Version compacte pour les headers
export const BenevolCheckLogoCompact = ({ size = 44, className = '' }) => (
  <img 
    src={LOGO_URL}
    alt="Bénévol'Check"
    width={size}
    height={size}
    className={className}
  />
);

// Icon seul (pour favicon)
export const BenevolCheckIcon = ({ size = 40, className = '' }) => (
  <img 
    src={LOGO_URL}
    alt="Bénévol'Check"
    width={size}
    height={size}
    className={className}
  />
);

export default BenevolCheckLogo;
